import { setRootVarFromElementHeight, setRootVarFromElementIdHeight, setRootVarFromElementIdWidth } from './setCssVars';

const recalculateLayoutOnce = () => {
  setRootVarFromElementIdHeight( '--height-header', 'header' );
  setRootVarFromElementIdHeight( '--height-admin-bar', 'wpadminbar' );
  setRootVarFromElementIdWidth( '--margin-left', 'title-inner' );
  setRootVarFromElementIdWidth( '--margin-right', 'footer-inner' );
  setRootVarFromElementIdHeight( '--height-main', 'barba-container' );

};
const recalculateLayoutEveryPage = (target) => {
  setRootVarFromElementHeight( '--height-main', target );
};

export { recalculateLayoutEveryPage, recalculateLayoutOnce };
